/** A released code is free again (tenant retirement §8 of the plan, CONTRACT §14): where ops pick a
 *  code for a new tenant, a code another tenant gave up says so — `previously_used_by` of
 *  `check_code` or of the easy-onboarding confirm card. Information only, never a refusal: the
 *  old company's installed apps, links and widget snippets name the code, and may reach the new
 *  tenant. */
import { Alert } from '@mui/material';

import type { PreviousCodeHolder } from '@/api/tourOperators';

const day = (iso: string | null) => (iso ? new Date(iso).toLocaleDateString() : null);

function holderWords(h: PreviousCodeHolder): string {
  const until = day(h.released_at);
  return until ? `${h.name} until ${until}` : h.name;
}

export function PreviouslyUsedByNote({ holders }: { holders: readonly PreviousCodeHolder[] }) {
  if (holders.length === 0) return null;
  const several = holders.length > 1;
  return (
    // A status, not an alert: it appears while typing and must not interrupt.
    <Alert severity="warning" role="status" data-previously-used-by>
      This code was used by {holders.map(holderWords).join(', and by ')}; installed apps, links and
      widget snippets of {several ? 'those companies' : 'that company'} may reach the new tenant.
    </Alert>
  );
}
